import $ from 'jquery';
import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { getFieldValueFromGridData } from '@bingads-webui-campaign/recommendation-core';
import { InlineEditableColumnPrompt } from '@bingads-webui-campaign/summary-grid-helper';
import { AdGroup } from '@bingads-webui-campaign/campaign-ui-schemas';
import { isPopupEditorEnabledRecommendationType, InlineCampaignAdGroupEditableSave } from '../const';

export class SuggestedShoppingAdGroupColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n, newI18n, recommendationType, view,
  }) {
    const title = newI18n.getString(_TL_('Suggested ad group'));
    super({
      name: 'AdGroupName',
      property: 'Opportunities/adgroupName',
      title,
      bodyClasses: ['grid-column-AdGroupName', 'actionable'],
      colClasses: ['col-middleText'],
      sortable: false,
      type: 'string',
      editable: isPopupEditorEnabledRecommendationType(recommendationType),
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.view = view;
  }

  template({
    value: {
      Opportunities,
    },
  }) {
    const opportunity = _.first(Opportunities);
    const adGroup = opportunity.NewAdGroupName || getFieldValueFromGridData(opportunity.GridData, 'AdGroupName');
    return adGroup;
  }

  get property() {
    return {
      get: _.identity,
      property: 'AdGroupName',
    };
  }

  onPrompt({
    event,
    item,
    newPosition,
  }) {
    if ($(event.target).is('a')) {
      return undefined;
    }

    const opportunity = _.first(item.Opportunities);
    _.extend(item, { Name: item.campaignName || getFieldValueFromGridData(opportunity.GridData, 'AdGroupName') });
    const key = $(event.target).parents('tr[data-key]').data('key');
    return InlineEditableColumnPrompt({
      position: newPosition,
      item,
      view: this.view,
      i18n: this.i18n,
      fieldName: 'Name',
      schema: AdGroup,
      saveModel: (updated, editorView) =>
        InlineCampaignAdGroupEditableSave({
          view: this.view,
          updated,
          key,
          editorView,
          isCampaign: false,
        }),
    });
  }
}
